import { ROLES_ARVAL, useAuth } from 'auth'
import { AGENDA_STATES, AGENDA_TASKS, AGENDA_TASKS_PARTNER } from 'lib/agenda'
import getOption, { OPTION_ALL_VALUE } from 'lib/getOption'
import { TABLE_DIRECTION_ASC, TABLE_DIRECTION_DESC } from 'lib/tableLib'
import { useState, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const useAgendaFilters = () => {
  const { t } = useTranslation()

  const { hasOneOfRoles } = useAuth()

  const allOption = useMemo(
    () => getOption(t('common.form.all'), OPTION_ALL_VALUE),
    [t]
  )

  const defaultFilters = useMemo(
    () => ({
      sessionIdQuery: '',
      publicationFrom: null,
      publicationTo: null,
      startDateFrom: null,
      startDateTo: null,
      endDateFrom: null,
      endDateTo: null,
      tasks: [OPTION_ALL_VALUE],
      states: [OPTION_ALL_VALUE],
      order: { column: 'state', direction: TABLE_DIRECTION_ASC },
    }),
    []
  )

  const admin = useMemo(() => hasOneOfRoles(ROLES_ARVAL), [hasOneOfRoles])

  const defaultFiltersData = useMemo(
    () => ({
      tasks: [
        allOption,
        ...(admin ? AGENDA_TASKS : AGENDA_TASKS_PARTNER).map((task) =>
          getOption(t(`agenda.task.${task}`), task)
        ),
      ],
      states: [
        allOption,
        ...AGENDA_STATES.map((state) =>
          getOption(t(`agenda.state.${state}`), state)
        ),
      ],
    }),
    [admin, allOption, t]
  )

  const [filters, setFilters] = useState({
    ...defaultFilters,
    initialized: false,
  })

  const [filtersData, setFiltersData] = useState({ ...defaultFiltersData })

  // const resetFilters = useCallback(() => {
  //   setFilters((s) => ({ ...s, ...defaultFilters }))
  // }, [defaultFilters])

  const initFilters = useCallback(() => {
    setFilters({ ...defaultFilters, initialized: true })

    setFiltersData({
      ...defaultFiltersData,
    })
  }, [defaultFilters, defaultFiltersData])

  const setSessionIdQuery = useCallback(
    (value) => {
      setFilters((s) => ({ ...s, sessionIdQuery: value }))
    },
    [setFilters]
  )

  const setTasks = useCallback(
    (value) => {
      setFilters((s) => ({ ...s, tasks: value }))
    },
    [setFilters]
  )

  const setStates = useCallback(
    (value) => {
      setFilters((s) => ({ ...s, states: value }))
    },
    [setFilters]
  )

  const setPublicationRange = useCallback(
    (publicationFrom, publicationTo) => {
      setFilters((s) => ({ ...s, publicationFrom, publicationTo }))
    },
    [setFilters]
  )

  const setStartDateRange = useCallback(
    (startDateFrom, startDateTo) => {
      setFilters((s) => ({ ...s, startDateFrom, startDateTo }))
    },
    [setFilters]
  )

  const setEndDateRange = useCallback(
    (endDateFrom, endDateTo) => {
      setFilters((s) => ({ ...s, endDateFrom, endDateTo }))
    },
    [setFilters]
  )

  const setSort = useCallback(
    (value) => {
      setFilters((s) => ({
        ...s,
        order: {
          column: value,
          direction:
            s.order.column !== value ||
            s.order.direction !== TABLE_DIRECTION_ASC
              ? TABLE_DIRECTION_ASC
              : TABLE_DIRECTION_DESC,
        },
      }))
    },
    [setFilters]
  )

  return {
    filters,
    filtersData,
    initFilters,
    setSessionIdQuery,
    setTasks,
    setStates,
    setPublicationRange,
    setStartDateRange,
    setEndDateRange,
    setSort,
    // resetFilters,
  }
}
export default useAgendaFilters
